define("shared/components/shared/video-thumbnail-list", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "@ember/utils", "@ember/runloop", "later/utils/time-format"], function (_exports, _component, _templateFactory, _object, _service, _component2, _tracking, _utils, _runloop, _timeFormat) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _initialPercentage, _updateBar, _getOffset, _getWidth, _adjustOffsetToNearestFrame, _adjustToNearestWholeFrame, _convertFrameToMs, _getPercentageOfOffset, _redrawSelectionWindow, _offsetWithinLast500ms, _notExpectedFramerate;

  0; //eaimeta@70e063a35619d71f0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/utils",0,"@ember/runloop",0,"later/utils/time-format",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <ul class={{if @class @class ""}} {{did-insert this.initVideoSnapshots}}>
    {{#if this.isLoaded}}
      {{#if @changeOffset}}
        {{!-- template-lint-disable no-down-event-binding --}}
        <div class="cVP--control__progress eVP--control__progress"
          {{on "mousedown" this.timeDragStart}}
          {{on "mouseup" this.timeDragEnd}} 
          {{on "mousemove" this.timeDragging}}
          {{did-update this.updateTime}}>
          <span class="cVP--control__thumbnails">
            {{#each snapshots as |snapshot|}}
              <li class="cVP--control__thumbnail">
                {{snapshot}}
              </li>
            {{/each}}
          </span>
          <span class="cVP--control__selection eVP--control__selection"></span>
        </div>
      {{else}}
        {{#each snapshots as |snapshot|}}
          <li class="tMM--scrubber__li">
            {{snapshot}}
          </li>
        {{/each}}      
      {{/if}}
    {{else}}
      {{#if @changeOffset}}
        <div class="cVP--control__progress eVP-control__progress">
          <Shared::LoadingSpinner/>
        </div>
      {{else}}
        <li class="tMM--scrubber__li">
          <Shared::LoadingSpinner/>
        </li>
      {{/if}}
    {{/if}}
  </ul>
  
  */
  {
    "id": "2ZH+RZAq",
    "block": "[[[11,\"ul\"],[16,0,[52,[30,1],[30,1],\"\"]],[4,[38,1],[[30,0,[\"initVideoSnapshots\"]]],null],[12],[1,\"\\n\"],[41,[30,0,[\"isLoaded\"]],[[[41,[30,2],[[[1,\"      \"],[11,0],[24,0,\"cVP--control__progress eVP--control__progress\"],[4,[38,2],[\"mousedown\",[30,0,[\"timeDragStart\"]]],null],[4,[38,2],[\"mouseup\",[30,0,[\"timeDragEnd\"]]],null],[4,[38,2],[\"mousemove\",[30,0,[\"timeDragging\"]]],null],[4,[38,3],[[30,0,[\"updateTime\"]]],null],[12],[1,\"\\n        \"],[10,1],[14,0,\"cVP--control__thumbnails\"],[12],[1,\"\\n\"],[42,[28,[37,5],[[28,[37,5],[[33,6]],null]],null],null,[[[1,\"            \"],[10,\"li\"],[14,0,\"cVP--control__thumbnail\"],[12],[1,\"\\n              \"],[1,[30,3]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[3]],null],[1,\"        \"],[13],[1,\"\\n        \"],[10,1],[14,0,\"cVP--control__selection eVP--control__selection\"],[12],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[42,[28,[37,5],[[28,[37,5],[[33,6]],null]],null],null,[[[1,\"        \"],[10,\"li\"],[14,0,\"tMM--scrubber__li\"],[12],[1,\"\\n          \"],[1,[30,4]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[4]],null]],[]]]],[]],[[[41,[30,2],[[[1,\"      \"],[10,0],[14,0,\"cVP--control__progress eVP-control__progress\"],[12],[1,\"\\n        \"],[8,[39,7],null,null,null],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,\"li\"],[14,0,\"tMM--scrubber__li\"],[12],[1,\"\\n        \"],[8,[39,7],null,null,null],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]]]],[]]],[13],[1,\"\\n\"]],[\"@class\",\"@changeOffset\",\"snapshot\",\"snapshot\"],false,[\"if\",\"did-insert\",\"on\",\"did-update\",\"each\",\"-track-array\",\"snapshots\",\"shared/loading-spinner\"]]",
    "moduleName": "shared/components/shared/video-thumbnail-list.hbs",
    "isStrictMode": false
  });

  // https://stackoverflow.com/questions/43007634/javascript-how-to-extract-frame-from-video?rq=1
  // https://stackoverflow.com/questions/19175174/capture-frames-from-video-with-html5-and-javascript
  // based on https://codepen.io/cindychen/pen/dwMgxm
  let VideoThumbnailList = (_class = (_initialPercentage = /*#__PURE__*/new WeakSet(), _updateBar = /*#__PURE__*/new WeakSet(), _getOffset = /*#__PURE__*/new WeakSet(), _getWidth = /*#__PURE__*/new WeakSet(), _adjustOffsetToNearestFrame = /*#__PURE__*/new WeakSet(), _adjustToNearestWholeFrame = /*#__PURE__*/new WeakSet(), _convertFrameToMs = /*#__PURE__*/new WeakSet(), _getPercentageOfOffset = /*#__PURE__*/new WeakSet(), _redrawSelectionWindow = /*#__PURE__*/new WeakSet(), _offsetWithinLast500ms = /*#__PURE__*/new WeakSet(), _notExpectedFramerate = /*#__PURE__*/new WeakSet(), class VideoThumbnailList extends _component2.default {
    get endTime() {
      return this.isFull ? this.mediaItemVideoDuration : this.pmiEndTime;
    }

    get formattedDuration() {
      // Note: use floor to be consistent with HTML player
      return (0, _timeFormat.timeFormat)(Math.floor(this.pmiDuration));
    }

    get isFull() {
      return this.args.displayType === 'full';
    }

    get maxDuration() {
      // The BE code moves the offset back by 500ms when the offset is set to the end of the video.
      return this.isFull ? this.mediaItemVideoDuration - 0.5 : this.pmiDuration - 0.5;
    }

    get mediaItem() {
      return this.args.postMediaItem.mediaItem;
    }

    get mediaItemVideoDuration() {
      return this.mediaItem.get('videoDuration');
    }

    get msPerFrame() {
      return this.videoFrameRate ? this.msPerSecond / this.videoFrameRate : 0;
    }

    get pmiDuration() {
      return this.args.postMediaItem.videoDuration;
    }

    get pmiEndTime() {
      return this.args.postMediaItem.endTime || this.mediaItemVideoDuration;
    }

    get pmiStartTime() {
      return this.args.postMediaItem.startTime;
    }

    get snapshots() {
      return this.editor.snapshots;
    }

    get startTime() {
      return this.isFull ? 0 : this.pmiStartTime || 0;
    }

    get thumbOffsetSeconds() {
      return this.args.postMediaItem.thumbOffset ? this.args.postMediaItem.thumbOffset / 1000 : 0;
    }

    get videoFrameRate() {
      return this.args.postMediaItem.mediaItem.get('videoFrameRate');
    }

    constructor() {
      super(...arguments);

      _classPrivateMethodInitSpec(this, _notExpectedFramerate);

      _classPrivateMethodInitSpec(this, _offsetWithinLast500ms);

      _classPrivateMethodInitSpec(this, _redrawSelectionWindow);

      _classPrivateMethodInitSpec(this, _getPercentageOfOffset);

      _classPrivateMethodInitSpec(this, _convertFrameToMs);

      _classPrivateMethodInitSpec(this, _adjustToNearestWholeFrame);

      _classPrivateMethodInitSpec(this, _adjustOffsetToNearestFrame);

      _classPrivateMethodInitSpec(this, _getWidth);

      _classPrivateMethodInitSpec(this, _getOffset);

      _classPrivateMethodInitSpec(this, _updateBar);

      _classPrivateMethodInitSpec(this, _initialPercentage);

      _initializerDefineProperty(this, "editor", _descriptor, this);

      _initializerDefineProperty(this, "scanTime", _descriptor2, this);

      _initializerDefineProperty(this, "isLoaded", _descriptor3, this);

      _initializerDefineProperty(this, "isTimeUpdate", _descriptor4, this);

      _initializerDefineProperty(this, "video", _descriptor5, this);

      _defineProperty(this, "msPerSecond", 1000);

      _defineProperty(this, "offsetHeight", 60);

      _defineProperty(this, "thumbnailCount", 8);

      _defineProperty(this, "expectedFrameRate", 30);

      this.scanTime = this.startTime;
    }

    didSeek(video) {
      const {
        videoWidth,
        videoHeight
      } = video;

      if (!this.isLoaded && !this.isDestroyed) {
        const theCanvas = document.createElement('canvas');
        const ratio = videoWidth / videoHeight;
        theCanvas.height = this.offsetHeight;
        theCanvas.width = this.offsetHeight * ratio; // Note: generate thumbnail URL data

        theCanvas.getContext('2d').drawImage(video, 0, 0, videoWidth, videoHeight, 0, 0, ratio * this.offsetHeight, this.offsetHeight);
        this.snapshots.pushObject(theCanvas);
        this.scanTime += this.maxDuration / this.thumbnailCount + 1;

        if (this.scanTime <= this.endTime) {
          video.currentTime = this.scanTime;
        } else {
          // set loaded and put the current time to the preferred offset
          this.isLoaded = true;

          if (typeof this.args.onLoad === 'function') {
            this.args.onLoad();
          }

          video.currentTime = this.startTime + this.thumbOffsetSeconds;
          (0, _runloop.next)(() => {
            const percentage = _classPrivateMethodGet(this, _initialPercentage, _initialPercentage2).call(this, video);

            _classPrivateMethodGet(this, _redrawSelectionWindow, _redrawSelectionWindow2).call(this, percentage);
          });
        }
      }
    }

    initVideoSnapshots() {
      this.video = document.getElementById(this.args.videoId);

      if (this.video) {
        const isNewPMI = !(0, _utils.isEqual)(this.editor.lastPMI, this.args.postMediaItem);
        const allSnapshotsLoaded = (0, _utils.isEqual)(this.snapshots.length, this.thumbnailCount);
        const initialSeekTime = 0.01;

        if (isNewPMI || !allSnapshotsLoaded) {
          this.editor.clearSnapshots();
          this.video.addEventListener('loadeddata', event => event.srcElement.currentTime = this.isFull ? initialSeekTime : Math.max(0.01, this.pmiStartTime || 0));
          this.video.addEventListener('seeked', event => this.didSeek(event.srcElement));
        } else {
          // set loaded and put the current time to the preferred offset
          this.isLoaded = true;

          if (typeof this.args.onLoad === 'function') {
            this.args.onLoad();
          }

          this.video.currentTime = this.startTime + this.thumbOffsetSeconds;
          (0, _runloop.next)(() => {
            const percentage = _classPrivateMethodGet(this, _initialPercentage, _initialPercentage2).call(this, this.video);

            _classPrivateMethodGet(this, _redrawSelectionWindow, _redrawSelectionWindow2).call(this, percentage);
          });
        }
      }
    }

    updateTime(event) {
      const currentPos = event.srcElement.currentTime;
      this.video.currentTime = (0, _timeFormat.timeFormat)(currentPos);
    }

    timeDragStart(event) {
      this.isTimeUpdate = true;

      _classPrivateMethodGet(this, _updateBar, _updateBar2).call(this, event.pageX);
    }

    timeDragging(event) {
      if (this.isTimeUpdate) {
        _classPrivateMethodGet(this, _updateBar, _updateBar2).call(this, event.pageX);
      }
    }

    timeDragEnd(event) {
      if (this.isTimeUpdate) {
        this.isTimeUpdate = false;

        _classPrivateMethodGet(this, _updateBar, _updateBar2).call(this, event.pageX);
      }
    }

  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "editor", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "scanTime", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return 0;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isLoaded", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isTimeUpdate", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "video", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "initVideoSnapshots", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "initVideoSnapshots"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateTime", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "timeDragStart", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "timeDragStart"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "timeDragging", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "timeDragging"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "timeDragEnd", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "timeDragEnd"), _class.prototype)), _class);
  _exports.default = VideoThumbnailList;

  function _initialPercentage2() {
    let percentage;

    if (this.isFull) {
      percentage = 0;
    } else {
      percentage = this.thumbOffsetSeconds / (this.pmiEndTime - this.pmiStartTime) * 100;
    }

    return percentage;
  }

  function _updateBar2(pageX) {
    const progress = document.querySelector('.eVP--control__progress'); // Note: calculate drag position and update video current time as well as progress bar

    const position = pageX - _classPrivateMethodGet(this, _getOffset, _getOffset2).call(this, progress).left;

    let percentage = 100 * position / _classPrivateMethodGet(this, _getWidth, _getWidth2).call(this, progress);

    if (percentage > 100) {
      percentage = 100;
    } else if (percentage < 0) {
      percentage = 0;
    }

    const milliseconds = this.maxDuration * percentage * 10;

    const {
      adjustedPercentage,
      adjustedOffsetInMs
    } = _classPrivateMethodGet(this, _adjustOffsetToNearestFrame, _adjustOffsetToNearestFrame2).call(this, milliseconds);

    _classPrivateMethodGet(this, _redrawSelectionWindow, _redrawSelectionWindow2).call(this, adjustedPercentage);

    const adjustedTimeInSeconds = adjustedOffsetInMs / this.msPerSecond + this.startTime;
    this.video.currentTime = adjustedTimeInSeconds;
    this.args.changeOffset(adjustedOffsetInMs);
  }

  function _getOffset2(el) {
    const rect = el.getBoundingClientRect();
    return {
      top: rect.top + window.pageYOffset - document.documentElement.clientTop,
      left: rect.left + window.pageXOffset - document.documentElement.clientLeft
    };
  }

  function _getWidth2(el) {
    return parseFloat(getComputedStyle(el, null).width.replace('px', ''));
  }

  function _adjustOffsetToNearestFrame2(milliseconds) {
    const offsetInMs = _classPrivateMethodGet(this, _adjustToNearestWholeFrame, _adjustToNearestWholeFrame2).call(this, milliseconds); // Note: also round to nearest ms to avoid rounding errors outside of app
    // Also round to nearest second if video framerate is expected to change


    let adjustedOffsetInMs;

    if (_classPrivateMethodGet(this, _offsetWithinLast500ms, _offsetWithinLast500ms2).call(this, offsetInMs)) {
      adjustedOffsetInMs = _classPrivateMethodGet(this, _notExpectedFramerate, _notExpectedFramerate2).call(this) ? Math.floor(offsetInMs / 1000) * 1000 : Math.floor(offsetInMs);
    } else {
      adjustedOffsetInMs = _classPrivateMethodGet(this, _notExpectedFramerate, _notExpectedFramerate2).call(this) ? Math.round(offsetInMs / 1000) * 1000 : Math.round(offsetInMs);
    }

    const adjustedPercentage = _classPrivateMethodGet(this, _getPercentageOfOffset, _getPercentageOfOffset2).call(this, adjustedOffsetInMs);

    return {
      adjustedPercentage,
      adjustedOffsetInMs
    };
  }

  function _adjustToNearestWholeFrame2(milliseconds) {
    const frameNumberSelected = this.msPerFrame ? milliseconds / this.msPerFrame : 0;

    if (frameNumberSelected) {
      return _classPrivateMethodGet(this, _convertFrameToMs, _convertFrameToMs2).call(this, Math.round(frameNumberSelected));
    }

    return milliseconds;
  }

  function _convertFrameToMs2(frame) {
    return this.msPerFrame * frame;
  }

  function _getPercentageOfOffset2(offsetInMs) {
    return offsetInMs / (this.maxDuration * 10);
  }

  function _redrawSelectionWindow2(percentage) {
    if (this.destroyed) {
      return;
    }

    const element = document.querySelector('.eVP--control__selection');

    if (element) {
      element.style.left = percentage + '%';
    }
  }

  function _offsetWithinLast500ms2(offsetInMs) {
    return Math.floor(this.pmiDuration) < offsetInMs / 1000 + 0.5;
  }

  function _notExpectedFramerate2() {
    return this.videoFrameRate !== this.expectedFrameRate;
  }

  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, VideoThumbnailList);
});